<template>
  <div class="wrap-detail">
    <div
      v-if="isLoading"
      class="box-loading"
    >
      <Skeleton
        width="100%"
        height="66px"
      />
      <b-row>
        <b-col
          v-for="i in 3"
          :key="i"
          cols="12"
          md="6"
          lg="4"
          class="col"
        >
          <Skeleton
            width="100%"
            height="412px"
          />
          <div class="box-dec-loading">
            <Skeleton
              v-for="i in 3"
              :key="i"
              width="100%"
              height="18px"
            />
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-if="!isLoading">
      <div class="box-title">
        {{ detailProps.first.title }}
      </div>
      <div class="box-contact">
        <b-row>
          <b-col
            v-for="(company, i) in detailProps.first.companies"
            :key="i"
            cols="12"
            md="3"
            class="col"
          >
          <div>
            <img :src="company.imgUrl">
            <div class="box-text">
              <p>{{ company.fullName }}</p>
              <p>{{ company.position }}</p>
              <p>{{ company.companyName }}</p>
            </div>
          </div>
          </b-col>
        </b-row>
      </div>
      <div class="box-content">
        <h3>{{ detailProps.second.title }}</h3>
        <div v-html="detailProps.second.dec"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const Skeleton = () => import('@/components/Loading/Skeleton')

export default {
  components: {
    Skeleton
  },

  props: {
    detailProps: Object
  },

  computed: {
    ...mapState({
      isLoading: state => state.creativity.isLoading
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-detail {
  padding: 22px 0;

  .box-loading {
    margin-bottom: 22px;

    .row {
      margin-top: 22px;

      .col {
        .box-dec-loading {
          margin-top: 32px;
          div {
            margin-top: 12px;
          }
        }
      }
    }
  }

  div {
    .box-title {
      padding: 12px 12px;
      background-color: $light;
      font-size: 1.25rem;
      color: black;

      @media only screen and (min-width: $break-m) {
        font-size: 1.75rem;
      }
    }

    .box-contact {
      margin-top: 22px;

      .row {
        .col {
          div {
            // @media only screen and (min-width: $break-m) {
            //   padding: 8px;
            // }

            img {
              width: 100%;
              height: auto;
              background-color: #CCC;

              // @media only screen and (min-width: $break-m) {
              //   height: 280px;
              // }

              // @media only screen and (min-width: $break-l) {
              //   height: 360px;
              // }
            }

            .box-text {
              padding: 16px 0;

              p {
                font-size: 1.5rem;
              }
            }
          }
        }
      }
    }

    .box-content {
      h3 {
        font-size: 1.75rem;
      }

      div {
        line-height: 1.2;
        font-size: 1.5rem;
      }
    }
  }
}
</style>
